import { render } from "./BlogSidebarAllonX.vue?vue&type=template&id=3b093523"
import script from "./BlogSidebarAllonX.vue?vue&type=script&lang=js"
export * from "./BlogSidebarAllonX.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__